import { contentQueryKeys } from 'actions/content';
import useFetchList from 'actions/useFetchList';
export default function useFetchMySharedContent() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    enabled = _ref.enabled;
  return useFetchList('me/shared', null, {
    queryKey: contentQueryKeys.mySharedContent,
    staleTime: 5 * 60 * 1000,
    enabled: enabled
  });
}